<script setup lang="ts">
const isShowContext: Ref<boolean> = ref(false);
provide('isShowContext', isShowContext);

const panelRef = ref<HTMLElement | null>(null);
const isOverflowLeft: Ref<boolean> = ref(false);
const isOverflowBottom: Ref<boolean> = ref(false);

const iconName: ComputedRef<string> = computed(() =>
  isShowContext.value ? 'Cross' : 'ContextMenu',
);

const updateOverflow = (): void => {
  const panel = panelRef.value;
  if (!panel) return;

  const rect = panel.getBoundingClientRect();
  if (rect.left < 0) isOverflowLeft.value = true;
  if (rect.bottom > window.innerHeight) isOverflowBottom.value = true;
};

useElementResize(panelRef, updateOverflow);

const toggleContext = (): void => {
  isShowContext.value = !isShowContext.value;
};

watch(isShowContext, (value) => {
  if (value) return;
  isOverflowLeft.value = false;
  isOverflowBottom.value = false;
});
</script>

<template>
  <div class="context-menu">
    <button
      :key="iconName"
      class="context-menu__button"
      aria-label="Меню действий"
      @click.prevent="toggleContext"
    >
      <AppIcon :name="iconName" />
    </button>
    <div
      v-if="isShowContext"
      ref="panelRef"
      :class="[
        'context-menu__panel',
        { '_overflow-left': isOverflowLeft },
        { '_overflow-bottom': isOverflowBottom },
      ]"
    >
      <slot :close="() => (isShowContext = false)"></slot>
    </div>
  </div>
</template>

<style lang="less">
.context-menu {
  width: @size-x5;
  height: @size-x5;
  position: relative;

  &__button {
    position: absolute;
    z-index: 2;
    width: @size-x5;
    height: @size-x5;
  }

  &__panel {
    position: absolute;
    top: -@size-x3;
    right: -@size-x3;
    z-index: 1;

    &._overflow-left {
      right: auto;
      left: -@size-x3;
    }

    &._overflow-bottom {
      top: auto;
      bottom: -@size-x3;
    }
  }
}
</style>
